import { config } from '@services/config';
import { QuoteUnderwritingTaskSearchResponse, QuoteUnderwritingTaskSearchRequestQuery } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { underwritingTasksQueryKeys } from '@services/underwritingTasks/keys';

const searchUWTasksQueryParams = ({
  pageLimit,
  pageOffset,
  includeTaskHistory,
}: QuoteUnderwritingTaskSearchRequestQuery) => {
  const queryString = new URLSearchParams();
  const queryParams: Partial<QuoteUnderwritingTaskSearchRequestQuery> = {};
  if (pageLimit) {
    queryParams.pageLimit = pageLimit;
    queryString.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    queryParams.pageOffset = pageOffset;
    queryString.append('pageOffset', String(pageOffset));
  }
  if (includeTaskHistory) {
    queryParams.includeTaskHistory = includeTaskHistory;
    queryString.append('includeTaskHistory', String(includeTaskHistory));
  }
  return {
    queryParams,
    queryString: queryString.toString(),
  };
};

export const useUWTasks = (
  params: QuoteUnderwritingTaskSearchRequestQuery & { quoteId: string | undefined },
  { isEnabled }: { isEnabled: boolean },
) => {
  const client = useClient();
  const { quoteId } = params;
  const { queryParams, queryString } = searchUWTasksQueryParams(params);
  // TODO: increase page limit if history is requested (new querystring param)
  const result = useQuery<QuoteUnderwritingTaskSearchResponse, Error>({
    queryKey: [...underwritingTasksQueryKeys.searchWithParams({ ...queryParams, quoteId: quoteId ?? '' })],
    // TODO: Implement proper paging controls
    queryFn: () =>
      client.get(`quote/${quoteId}/underwriting-task?${queryString}`).json<QuoteUnderwritingTaskSearchResponse>(),
    enabled: Boolean(quoteId) && isEnabled,
    ...config,
  });
  return {
    ...result,
    underwritingTasks: result.data,
    refetchTasks: result.refetch,
  };
};
